import localization from '@/localization'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

import IDossierEtudiant from './IDossierEtudiant.model'
import IInscriptionLieuExamenInformations from './IInscriptionLieuExamenInformations.model'
import ITypeInscriptionLieuExamen from './ITypeInscriptionLieuExamen.model'

export enum STORE_ACTIONS {
  INSCRIPTION_LIEU_EXAMEN_STORE_INFORMATIONS = 'inscriptionLieuExamen/storeInformations',
  INSCRIPTION_LIEU_EXAMEN_STORE_DOSSIER_ETUDIANT = 'inscriptionLieuExamen/storeDossierEtudiant',
  INSCRIPTION_LIEU_EXAMEN_STORE_TYPES_INSCRIPTION_LIEU_EXAMEN = 'inscriptionLieuExamen/storeTypesInscriptionLieuExamen',
  INSCRIPTION_LIEU_EXAMEN_UPDATE_TYPE_INSCRIPTION_LIEU_EXAMEN_LOADING_STATE = 'inscriptionLieuExamen/updateTypeInscriptionLieuExamenLoadingState',
  INSCRIPTION_LIEU_EXAMEN_STORE_UPDATE_TOKEN = 'inscriptionLieuExamen/updateToken'
}

export enum STORE_GETTERS {
  INSCRIPTION_LIEU_EXAMEN_GET_INFORMATIONS = 'inscriptionLieuExamen/informations',
  INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT = 'inscriptionLieuExamen/dossierEtudiant',
  INSCRIPTION_LIEU_EXAMEN_GET_TYPES_INSCRIPTION_LIEU_EXAMEN = 'inscriptionLieuExamen/typesInscriptionLieuExamen',
  INSCRIPTION_LIEU_EXAMEN_GET_TYPES_INSCRIPTION_LIEU_EXAMEN_BY_SLUG = 'inscriptionLieuExamen/typesInscriptionLieuExamenBySlug',
  INSCRIPTION_LIEU_EXAMEN_GET_IS_TYPE_INSCRIPTION_LIEU_EXAMEN_LOADING_STATE_ACTIVE = 'inscriptionLieuExamen/isTypeInscriptionLieuExamenLoadingStateActive',
  INSCRIPTION_LIEU_EXAMEN_GET_TOKEN = 'inscriptionLieuExamen/token',
  INSCRIPTION_LIEU_EXAMEN_GET_MESSAGE_IMPORTANT = 'inscriptionLieuExamen/messageImportant'
}

@Module({ namespaced: true })
export default class InscriptionLieuExamenStore extends VuexModule {
  private _informations: IInscriptionLieuExamenInformations | null = null
  private _dossierEtudiant: IDossierEtudiant | null = null
  private _typesInscriptionLieuExamen: Array<ITypeInscriptionLieuExamen> = []
  private _isTypeInscriptionLieuExamenLoadingStateActive: boolean = false
  private _token: string = ''

  @Mutation
  private storeInformationsMutation(informations: IInscriptionLieuExamenInformations): void {
    this._informations = informations || null
  }

  @Mutation
  private storeDossierEtudiantMutation(dossierEtudiant: IDossierEtudiant): void {
    this._dossierEtudiant = dossierEtudiant || null
  }

  @Mutation
  private storeTypesInscriptionLieuExamenMutation(typesInscriptionLieuExamen: Array<ITypeInscriptionLieuExamen> = []): void {
    this._typesInscriptionLieuExamen = typesInscriptionLieuExamen || []
  }

  @Mutation
  private updateTypeInscriptionLieuExamenLoadingStateMutation(newState: boolean = false): void {
    this._isTypeInscriptionLieuExamenLoadingStateActive = newState || false
  }

  @Mutation
  private updateTokenMutation(token: string): void {
    this._token = token || ''
  }

  @Action
  public storeInformations(informations: IInscriptionLieuExamenInformations): void {
    this.context.commit('storeInformationsMutation', informations)
  }

  @Action
  public storeDossierEtudiant(dossierEtudiant: IDossierEtudiant): void {
    this.context.commit('storeDossierEtudiantMutation', dossierEtudiant)
  }

  @Action
  public storeTypesInscriptionLieuExamen(typesInscriptionLieuExamen: Array<ITypeInscriptionLieuExamen>): void {
    this.context.commit('storeTypesInscriptionLieuExamenMutation', typesInscriptionLieuExamen)
  }

  @Action
  public updateTypeInscriptionLieuExamenLoadingState(newState: boolean = false): void {
    this.context.commit('updateTypeInscriptionLieuExamenLoadingStateMutation', newState)
  }

  @Action
  public updateToken(token: string): void {
    this.context.commit('updateTokenMutation', token)
  }

  private get informations(): IInscriptionLieuExamenInformations | null {
    return this._informations
  }

  private get dossierEtudiant(): IDossierEtudiant | null {
    return this._dossierEtudiant
  }

  private get typesInscriptionLieuExamen(): Array<ITypeInscriptionLieuExamen> {
    return this._typesInscriptionLieuExamen || []
  }

  private get typesInscriptionLieuExamenBySlug(): { [key: string]: ITypeInscriptionLieuExamen } {
    return this._typesInscriptionLieuExamen.reduce((acc: { [key: string]: ITypeInscriptionLieuExamen }, typeInscriptionLieuExamen: ITypeInscriptionLieuExamen) => {
      return {
        ...acc,
        [typeInscriptionLieuExamen.slug]: typeInscriptionLieuExamen
      }
    }, {})
  }

  private get isTypeInscriptionLieuExamenLoadingStateActive(): boolean {
    return this._isTypeInscriptionLieuExamenLoadingStateActive || false
  }

  private get token(): string {
    return this._token
  }

  private get messageImportant(): string | null {
    if (!this._informations) {
      return null
    }

    const message: string | null = this._informations.messagesImportantLocalise[localization.CURRENT_LOCALE]

    return message ||
      this._informations.messagesImportantLocalise[localization.FALLBACK_LOCALE]
  }
}
